export default function Reddit(props) {
  return (
    <svg width='32.57' height='32.57' viewBox='0 0 32.57 32.57' {...props}>
      <g transform='translate(-2223 -1162)'>
        <circle cx='16.285' cy='16.285' r='16.285' transform='translate(2223 1162)' />
        <path
          d='M15.568,6.828,1.213.076A.857.857,0,0,0,.748.007.761.761,0,0,0,.322.195.842.842,0,0,0,.045.581a.8.8,0,0,0-.02.465l1.03,4.1L7.608,7.6,1.055,10.055l-1.03,4.1a.8.8,0,0,0,.02.465A.842.842,0,0,0,.322,15a.631.631,0,0,0,.238.148.877.877,0,0,0,.3.049.777.777,0,0,0,.168-.02,1.224,1.224,0,0,0,.188-.059L15.568,8.372a1,1,0,0,0,.356-.327.785.785,0,0,0,0-.891A1,1,0,0,0,15.568,6.828Z'
          transform='translate(2232.477 1170.397)'
          fill='#fff'
        />
      </g>
    </svg>
  )
}
